import { createFileRoute } from '@tanstack/react-router';
import { PortalExtrasStepForm } from './-components/portal-new-steps/extras-step';

export const Route = createFileRoute('/ngos/portals/$portalId_/setup/extras')({
	component: PortalExtrasStepForm,
});
